import React from 'react';
import Home from './routes/home';
import { Route, Routes } from 'react-router-dom';
import './styles/global.css';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
    </Routes>
  );
}
